import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnEvidenceCase extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public description: string;

  @Expose()
  public status: string;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
